import classNames from 'classnames';
import { inject, PropTypes as MobxPropTypes, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import globalTranslations from '../../../i18n/globalTranslations';
import Order from '../../../models/order/Order';
import RecurringOrder from '../../../models/RecurringOrder';
import { modelOf } from '../../../prop-types';
import OrderListHeading from '../OrderListHeading';
import OrderPreview from '../OrderPreview';
import RecurringOrderPreview from '../RecurringOrderPreview';

const OrderList = ({
  orders,
  onClearProductListFilter,
  onFilterByDate,
  onFilterByText,
  onRemoveClick,
  onSelectSort,
  onSelectSortOrder,
  orderCount,
  ordersFiltered,
  showFilters,
  showHeading,
  selectedSortOrderBy,
  selectedSortOrder,
  useRecurringOrders,
}) => {
  const renderOrderRows = () => {
    return orders.map((order) => {
      return useRecurringOrders ? (
        <RecurringOrderPreview
          key={order.id}
          order={order}
          onRemoveClick={onRemoveClick}
        />
      ) : (
        <OrderPreview key={order.id} order={order} />
      );
    });
  };

  const renderHeading = () => {
    return (
      <OrderListHeading
        orderCount={orderCount}
        onFilterByDate={onFilterByDate}
        onFilterByText={onFilterByText}
        onClearProductListFilter={onClearProductListFilter}
        onSelectSort={onSelectSort}
        onSelectSortOrder={onSelectSortOrder}
        selectedSortOrderBy={selectedSortOrderBy}
        selectedSortOrder={selectedSortOrder}
        showFilters={showFilters}
      />
    );
  };

  const renderOrders = () => {
    if (orders.length === 0 && !ordersFiltered) {
      return (
        <div className="OrderList__no-orders">
          <FormattedMessage {...globalTranslations.myAccountNoOrders} />
        </div>
      );
    } else if (orders.length === 0 && ordersFiltered) {
      return (
        <div className="OrderList__no-orders-found">
          <FormattedMessage {...globalTranslations.myAccountNoOrdersFound} />
        </div>
      );
    }

    return renderOrderRows();
  };

  return (
    <div className="OrderList">
      {showHeading && renderHeading()}
      <div
        className={classNames('OrderList__orders', {
          'OrderList__recurring-orders': useRecurringOrders,
        })}
      >
        {renderOrders()}
      </div>
    </div>
  );
};

OrderList.propTypes = {
  orders: PropTypes.oneOfType([
    MobxPropTypes.observableArrayOf(modelOf(Order)),
    MobxPropTypes.observableArrayOf(modelOf(RecurringOrder)),
    PropTypes.array,
  ]),
  onClearProductListFilter: PropTypes.func,
  onFilterByDate: PropTypes.func.isRequired,
  onFilterByText: PropTypes.func.isRequired,
  onRemoveClick: PropTypes.func.isRequired,
  onSelectSort: PropTypes.func.isRequired,
  onSelectSortOrder: PropTypes.func.isRequired,
  orderCount: PropTypes.number,
  selectedSortOrder: PropTypes.string,
  selectedSortOrderBy: PropTypes.string,
  showFilters: PropTypes.bool,
  showHeading: PropTypes.bool,
  ordersFiltered: PropTypes.bool,
  useRecurringOrders: PropTypes.bool,
};

export default inject('recurringOrderStore')(observer(OrderList));
